import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface SetActiveProfileResponse extends BackendResponse {}

export interface SetActiveProfileParameters extends NextApiParams {
  k: number;
  candidateId: number;
}

/** Backend message returned when SetActiveProfile is called for a candidate
 *  whose email the user hasn't verified. Kept in sync with
 *  AuthController.MsgProfileEmailNotVerified. */
export const MSG_PROFILE_EMAIL_NOT_VERIFIED = "Profile email not verified";

export const setActiveProfile = withNextApi<
  SetActiveProfileResponse,
  SetActiveProfileParameters
>("/auth/SetActiveProfile");
